import OrderItemService from '@/services/pdv-balcao/OrderItemService'
import store from '@/store/index'
export const orderItensModule = {
  namespaced: true,
  strict: process.env.NODE_ENV !== 'production',
  state: {
    ITENS: [],
    orderItens: [],
  },
  mutations: {
    UPDATE_ORDER_ITEM(state, payload) {
      state.orderItens.findIndex((item) => item.CODIGO === payload.CODIGO)
    },
    CLEAR_ORDER_ITENS(state) {
      state.orderItens = []
    },
    SET_ORDER_ITENS(state, payload) {
      state.orderItens = payload
    },
  },
  actions: {
    async addOrderItem({ dispatch, state }, payload) {
      let service = new OrderItemService()
      let item
      let itensUpdate = []
      let itens = []
      if (!payload.ITENS) {
        item = state.orderItens.find(
          (element) =>
            element.item.CODIGO === payload.ITEM.CODIGO &&
            payload.ITEM.CODIGO !== store.state.systemModule.codigoItemDiversos
        )
        //Caso encontre item duplicado, vai somar a quantidade
        //e atualizar na API

        if (item) {
          item.QUANTIDADE =
            parseFloat(item.QUANTIDADE) + parseFloat(payload.QUANTIDADE)
          return await dispatch('updateOrderItem', item)
        } else {
          const response = await service.insertOrderItem(payload)
          await dispatch('getOrderItens', {
            orcamento: payload.SEQUENCIALORCAMENTO,
          })

          return response
        }
      } else {
        payload.ITENS.forEach((el) => {
          item = state.orderItens.find((e) => e.ITEM == el.ITEM.CODIGO)
          if (item) {
            item.QUANTIDADE =
              parseFloat(el.QUANTIDADE) + parseFloat(item.QUANTIDADE)
            itensUpdate.push(item)
          } else {
            itens.push(el)
          }
        })
        let responseInsert = []
        let responseUpdate = []
        if (itensUpdate.length > 0) {
          responseUpdate = await dispatch('updateOrderItem', itensUpdate)
        }
        if (itens.length > 0) {
          responseInsert = await service.insertOrderItem({ ITENS: itens })
          await dispatch('getOrderItens', {
            orcamento: payload.SEQUENCIALORCAMENTO,
          })
        }
        Array.prototype.push.apply(
          responseInsert.error ?? [],
          responseUpdate.error ?? []
        )
        return responseInsert
      }
    },
    async removeOrderItem({ dispatch }, payload) {
      let service = new OrderItemService()
      let response = await service.delete(payload.SEQUENCIAL)
      dispatch('getOrderItens', {
        orcamento: payload.SEQUENCIALORCAMENTO,
      })
      return response.status
    },
    async updateOrderItem({ commit, dispatch }, item) {
      let service = new OrderItemService()
      let orderItem = ''
      if (!Array.isArray(item)) {
        orderItem = { ...item }
        orderItem.DEPARTAMENTO = orderItem.DEPARTAMENTO
          ? { CODIGO: orderItem.DEPARTAMENTO }
          : null
        // só o necessário para o backend
        orderItem.ITEM = { CODIGO: orderItem.item.CODIGO }
      } else {
        item.forEach((e) => {
          e.DEPARTAMENTO = e.DEPARTAMENTO ? { CODIGO: e.DEPARTAMENTO } : null
          // só o necessário para o backend
          e.ITEM = { CODIGO: e.item.CODIGO }
        })
        orderItem = { ITENS: item }
      }

      let response = await service.update(
        orderItem,
        !Array.isArray(orderItem) ? orderItem.SEQUENCIAL : null
      )
      if (response.status) {
        await commit('UPDATE_ORDER_ITEM', item)
        await dispatch('getOrderItens', {
          orcamento: !Array.isArray(orderItem.ITENS)
            ? orderItem.SEQUENCIALORCAMENTO
            : orderItem.ITENS[0].SEQUENCIALORCAMENTO,
        })
      }

      return response
    },
    async resetOrderItens({ commit }) {
      await commit('CLEAR_ORDER_ITENS')
    },
    async removeAllOrderItens({ commit, state }) {
      let service = new OrderItemService()
      state.orderItens.forEach(async (element) => {
        await service.delete(element.SEQUENCIAL)
      })
      await commit('CLEAR_ORDER_ITENS')
    },
    async getOrderItens({ commit, dispatch }, payload) {
      let service = new OrderItemService()
      let orderItens = await service.getOrderItens(payload)
      dispatch('resetOrderItens')
      commit('SET_ORDER_ITENS', orderItens)
    },
  },
  getters: {
    getOrderItems: (state) => {
      return state.orderItens.map((orderItem) => ({
        ...orderItem,
        VALORTOTAL:
          parseFloat(orderItem.QUANTIDADE) * parseFloat(orderItem.PRECO),
      }))
    },
  },
}
